import { call, put, takeLatest } from "redux-saga/effects";
import {
  onReviewPost,
  onReviewPostSuccess,
  onReviewPostError,
  onGetReviews,
  onGetReviewsSuccess,
  onGetReviewsError,
} from "../Store/Slices/reviewSlice";
import { callGetReviewsApi, callReviewPostApi } from "../Context/businessApi";

function* reviewPostSaga({ payload }) {
  try {
    const response = yield call(callReviewPostApi, payload ?? {});
    const code = response.httpStatusCode ?? response.status;
    if (code === "200" || code === 200 || code === 201 || code === "201") {
      yield put(
        onReviewPostSuccess({
          message: response.message || "Review submitted successfully",
          status_code: code,
        }),
      );
    } else {
      yield put(
        onReviewPostError({
          message: response.message || "Failed to submit review",
          status_code: code,
        }),
      );
    }
  } catch (error) {
    yield put(onReviewPostError({ data: null, message: error.message, status_code: 400 }));
  }
}

function* getReviewsSaga({ payload }) {
  try {
    const response = yield call(callGetReviewsApi, payload);
    const code = response.httpStatusCode ?? response.status;
    if (code === "200" || code === 200) {
      yield put(
        onGetReviewsSuccess({
          data: response.data ?? null,
          message: response.message,
          status_code: code,
        }),
      );
    } else {
      yield put(
        onGetReviewsError({ data: response.data ?? null, message: response.message, status_code: code }),
      );
    }
  } catch (error) {
    yield put(onGetReviewsError({ data: null, message: error.message, status_code: 400 }));
  }
}

export default function* reviewSaga() {
  yield takeLatest(onReviewPost.type, reviewPostSaga);
  yield takeLatest(onGetReviews.type, getReviewsSaga);
}
